import { createContext, useContext, useMemo, useState } from "react";

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const initial = localStorage.getItem("gos_country") || "canada";
  const [countrySlug, _setCountry] = useState(initial);
  const setCountry = (slug) => {
    localStorage.setItem("gos_country", slug);
    _setCountry(slug);
  };
  const value = useMemo(() => ({ countrySlug, setCountry }), [countrySlug]);
  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
}

export const useCountry = () => useContext(CountryContext);
